import Attachment from './Attachment';
import NameCard from './nameCard/NameCard';
import Button from './Button';
import Label from './Label';
import Icon from './Icon';
import BreadCrumb from './breadcrumb/BreadCrumb';
import BreadCrumbItem from './breadcrumb/BreadCrumbItem';
import Spinner from './Spinner';
import Tip from './Tip';
import Chip from './Chip';
import LoadMore from './LoadMore';
import Pagination from './pagination/Pagination';
import ReportPagination from './reportPagination/ReportPagination';
import ModalTrigger from './ModalTrigger';
import ModalTriggerUI from './ModalTriggerUI';
import ActionButtons from './ActionButtons';
import EmptyState from './EmptyState';
import Bulk from './Bulk';
import Filter from './filter/Filter';
import Tags from './Tags';
import FilterableList from './filterableList/FilterableList';
import DropdownToggle from './DropdownToggle';
import CustomDropdown from './Dropdown';
import ImportFile from './ImportFile';
import ChooserSelector from './ChooserSelector';
import InfoDetail from './InfoDetail';
import {
  FormControl,
  ControlLabel,
  FormGroup,
  Textarea,
  SelectWithSearch
} from './form';
import { Step, Steps, ConditionStep } from './step';
import TextDivider from './TextDivider';
import CountsByTag from './CountsByTag';
import FilterByParams from './FilterByParams';
import Table from './table';
import Editor from './editor/Editor';
import { Tabs,
  //  TabList
    TabTitle } from './tabs';
import ConfirmDialog from './ConfirmDialog';
import DataWithLoader from './DataWithLoader';
import SortableList from './SortableList';
import ImageWithPreview from './ImageWithPreview';
import IntegrationIcon from './IntegrationIcon';
import Chooser from './Chooser';
import DateFilter from './DateFilter';
import PhoneFilter from './PhoneFilter';
import ModifiableSelect from './ModifiableSelect';
import SortHandler from './SortHandler';
import ProjectFilter from './ProjectFilter';
import AudioPlayer from './AudioPlayer';
import VariableList from './VariableList';
import Stages from './Stages';
import ButtonCommonTheme from './ButtonCommonTheme';
// TODO remove
const pagination = {};

export {
  Attachment,
  ActionButtons,
  NameCard,
  ButtonCommonTheme,
  Button,
  Label,
  Icon,
  BreadCrumb,
  BreadCrumbItem,
  Spinner,
  Tip,
  LoadMore,
  Chip,
  Pagination,
  ProjectFilter,
  pagination,
  ReportPagination,
  ModalTrigger,
  ModalTriggerUI,
  EmptyState,
  Bulk,
  CountsByTag,
  Filter,
  FilterByParams,
  Tags,
  FilterableList,
  DropdownToggle,
  CustomDropdown,
  FormControl,
  Textarea,
  ControlLabel,
  FormGroup,
  Step,
  Steps,
  ConditionStep,
  TextDivider,
  Table,
  Editor,
  Tabs,
  // TabList,
  PhoneFilter,
  TabTitle,
  ConfirmDialog,
  DataWithLoader,
  SortableList,
  ImageWithPreview,
  IntegrationIcon,
  Chooser,
  DateFilter,
  ModifiableSelect,
  SortHandler,
  SelectWithSearch,
  ChooserSelector,
  AudioPlayer,
  ImportFile,
  VariableList,
  Stages,
  InfoDetail,
};



// WEBPACK FOOTER //
// src/modules/common/components/index.js